// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"51":"0b0902f9","376":"a4d93568","505":"87f81dce","620":"83a38a38","660":"6e203468","941":"92b045de"}[chunkId] + ".css";
};